(function (angular) {
	angular.module('bizPartEngage').service('modules.dictionary.service', dictionaryService);

	dictionaryService.$inject = ["$http"];

	function dictionaryService($http) {
		this.GetAllEntries = function (id) {
			return $http.get(siteRootPath + 'api/dictionary/GetAllEntries?' + $.param({ cultureId: id }));
		};
		this.GetAllEntriesWCategories = function (categories = '') {
			return $http.get(siteRootPath + 'api/dictionary/GetAllEntriesWCategories?' + $.param({ categoriesCommaSep: categories }));
		};

	}

})(window.angular);
